const getCurrentUserId = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user?.token.idUser;
};

export default getCurrentUserId;
